document.addEventListener("DOMContentLoaded", () => {

  let slideObserver = null;
  let bodyObserver = null;
  let rafId = null;

  const createOrUpdateHeading = () => {
    const activeSlide = document.querySelector('.pswp_lf__item[aria-hidden="false"]');
    if (!activeSlide) return;

    const img = activeSlide.querySelector("img.pswp_lf__img");
    if (!img) return;

    const sourceItem = document.querySelector(
      `.kt-image-lightbox[data-img="${img.src}"]`
    );

    const title =
      sourceItem?.textContent?.trim() ||
      sourceItem?.dataset?.title ||
      img.alt ||
      "";

    if (!title) return;

    let caption = activeSlide.querySelector(".lf-lightbox-heading");

    if (!caption) {
      caption = document.createElement("div");
      caption.className = "lf-lightbox-heading";
      activeSlide.appendChild(caption);
    }

    if (caption.textContent !== title) {
      caption.textContent = title;
    }
  };

  const observeSlides = (popup) => {
    const container = popup.querySelector(".pswp_lf__container");
    if (!container) return;

    if (slideObserver) slideObserver.disconnect();

    slideObserver = new MutationObserver(() => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(createOrUpdateHeading);
    });

    slideObserver.observe(container, {
      attributes: true,
      subtree: true,
      attributeFilter: ["aria-hidden"]
    });

    // Run immediately
    createOrUpdateHeading();
  };

  const observeLightbox = () => {

    if (bodyObserver) bodyObserver.disconnect();

    bodyObserver = new MutationObserver(() => {
      const popup = document.querySelector(".pswp_lf");

      if (popup && popup.classList.contains("pswp_lf--open")) {
        observeSlides(popup);
      } else {
        // Cleanup when closed
        if (slideObserver) {
          slideObserver.disconnect();
          slideObserver = null;
        }
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  observeLightbox();

});

// document.addEventListener("DOMContentLoaded", () => {
//   const gallery = document.querySelector(".kt-type-main");
//   if (!gallery) return;

//   const animateItems = () => {
//     const items = gallery.querySelectorAll(".lf-image-item");

//     items.forEach(item => {
//       // Reset first (important!)
//       item.style.transition = "none";
//       item.style.opacity = "0";
//       item.style.transform = "scale(0.85)";

//       // Force reflow (this makes browser restart animation)
//       void item.offsetWidth;

//       // Apply animation again
//       item.style.transition = "opacity 0.4s ease, transform 0.4s ease";
//       item.style.opacity = "1";
//       item.style.transform = "scale(1)";
//     });
//   };

//   // Debounce for fast filter clicks
//   let timeout;
//   const triggerAnimation = () => {
//     clearTimeout(timeout);
//     timeout = setTimeout(animateItems, 80);
//   };

//   document.querySelectorAll(".lf-filters a").forEach(btn => {
//     btn.addEventListener("click", triggerAnimation);
//   });
// });

document.addEventListener("DOMContentLoaded", function() {

  const commercialBtn = document.querySelector('a[href="#commercialestimate"]');
  const residentialBtn = document.querySelector('a[href="#residentialestimate"]');

  const commercialForm = document.getElementById("qVRUxrZS6GF56BfD5i2JJw");
  const residentialForm = document.getElementById("k0LOpIKgmv-Gy9tRUTl2Sw");

  commercialBtn.addEventListener("click", function(e) {
    e.preventDefault();

    commercialForm.classList.add("estimate-active");
    residentialForm.classList.remove("estimate-active");

    // commercialForm.scrollIntoView({ behavior: "smooth" });
  });

  residentialBtn.addEventListener("click", function(e) {
    e.preventDefault();

    residentialForm.classList.add("estimate-active");
    commercialForm.classList.remove("estimate-active");

    // residentialForm.scrollIntoView({ behavior: "smooth" });
  });

});